import React from 'react';
import { Users, Eye, Trash2 } from 'lucide-react';
import type { GroupeWithCounts } from '@/types/group.types';

interface Props {
  group: GroupeWithCounts;
  canManage?: boolean; // Permission to manage (delete) groups
  onView: () => void;
  onDelete: () => void;
}

const GroupCard: React.FC<Props> = ({ group, canManage = true, onView, onDelete }) => {
  const isFull = group.maxStudents && group.studentCount >= group.maxStudents;
  const isFC = group.typeFormation === 'CONTINUE';

  return (
    <div
      className={`p-3 rounded-lg border transition-all ${
        isFC
          ? 'bg-purple-50 border-purple-200'
          : 'bg-white border-gray-200 hover:border-primary-300'
      }`}
    >
      <div className="flex items-center justify-between mb-2">
        <h5 className={`text-sm font-medium ${isFC ? 'text-purple-900' : 'text-gray-900'}`}>
          {group.name}
        </h5>
        <div className="flex items-center gap-1">
          <button
            onClick={onView}
            className={`p-1 rounded hover:bg-gray-200 ${isFC ? 'text-purple-600' : 'text-gray-500'}`}
            title="Voir les étudiants"
          >
            <Eye className="h-4 w-4" />
          </button>
          {canManage && (
            <button
              onClick={onDelete}
              className="p-1 rounded text-red-500 hover:bg-red-50"
              title="Supprimer le groupe"
            >
              <Trash2 className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>

      <div className="flex items-center gap-2 text-xs">
        <div className="flex items-center gap-1 text-gray-600">
          <Users className="h-3 w-3" />
          <span>
            {group.studentCount}
            {group.maxStudents && ` / ${group.maxStudents}`}
          </span>
        </div>
        {isFull && (
          <span className="px-1.5 py-0.5 bg-red-100 text-red-700 rounded text-[10px] font-medium">
            Complet
          </span>
        )}
        {isFC && (
          <span className="px-1.5 py-0.5 bg-purple-200 text-purple-700 rounded text-[10px] font-medium">
            FC
          </span>
        )}
      </div>
    </div>
  );
};

export default GroupCard;
